import { ApplicationRoutes } from './ApplicationRoutes';

export function App() {
  return <ApplicationRoutes />;
}
